import ViewBase from "../../view-base.view";
import { Button } from "construct-ui";
import { formats as FORMATS } from '../../../config/constants';
import moment from "moment";


export default function SendToJPOResultView() {

  ViewBase.call(this);

  let data = [];
  let onClose = (isModalOpen) => { }

  let closeModal = function () {
    onClose(false);
  }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.onClose) {
        onClose = vnode.attrs.onClose;
      }
      if (vnode.attrs.JPOresult) {

        data = vnode.attrs.JPOresult;
      }
    },

    view: (vnode) => {
      return [m('.card',
        m('.card-body',
          m('.row.g-2',
            m('.col-12',
              m('.table-responsive',
                m('table.table.table-sm',
                  m('thead',
                    m('tr.align-middle.center',
                      m('th', this.getText("LT00000049", "User ID")),
                      m('th', this.getText('LT00008149', 'Schedule Date')),
                      m('th', this.getText('LT00000015', 'Status')),
                      m('th', this.getText('LT00000152', 'Remarks'))
                    )
                  ),
                  m('tbody',
                    data?.length === 0 &&
                    m("tr",
                      { class: "align-middle" },
                      m("td",
                        { colspan: "100%" },
                        this.getText("EM00000141", "No records found.")
                      )
                    ),
                    data?.length > 0 &&
                    data.map((item) => {
                      return m('tr.align-middle.center',
                        { style: { background: item.statusCode === 'SUCCESS' ? '#e2fff2' : '#fadcd7' } },
                        m('td', m('span.cursor-text', item.userId)),
                        m('td', m('span.cursor-text', moment(item.scheduleDate).format(FORMATS.dateFormat))),
                        m('td', m('span.cursor-text', item.statusCode)),
                        m('td', { style: { "white-space": "initial" } }, m('span.cursor-text', item.statusMessage)),
                      )
                    })
                  )
                )
              )
            )
          )
        )),
      m('.d-flex.justify-content-center.mb-1.mt-4',
        m(Button, {
          outlined: true,
          label: this.getText("LT00000021", "Close"),
          onclick: closeModal
        })
      ),
      this.getBaseViews()]
    }
  }
}